import React, { Component } from 'react';
import { IconButton } from '@fluentui/react/lib/Button';

export class Collapsible extends Component {
    static displayName = Collapsible.name;

    constructor(props) {
        super(props);
        // Why isn't this working?

        this.state = { isCollapsed: props.startCollapsed };
        this.onHeaderClicked = this.onHeaderClicked.bind(this);
    }
    componentDidMount() {

    }
    onHeaderClicked() {
        this.setState({ isCollapsed: !this.state.isCollapsed });
    }
    render() {
        var header = this.props.header ? this.props.header : "Collapsible";
        var icon = this.state.isCollapsed ? "ChevronUp" : "ChevronDown";
        var buttonTitle = this.state.isCollapsed ? "Open" : "Close";
        var printNames = "";
        if (this.state.isCollapsed == true) {
            printNames = "d-print-none"
        }
        return (

            <div style={{ marginTop: "30px" }}>
                <h4 onClick={this.onHeaderClicked} className={printNames}><IconButton className="d-print-none" iconProps={{ iconName: icon }} title={buttonTitle} ariaLabel={buttonTitle} />{header}</h4>
                { this.state.isCollapsed == false &&
                    <div>{this.props.children}</div>
                }
            </div>
        )
    }
}

Collapsible.defaultProps = {
    startCollapsed: true
}
